<template>
	<div class="app-container">
		<div class="header">
			<!-- <el-input size="medium" v-model="search" placeholder="输入汽车品牌,按回车键搜索" @keyup.enter.native="brandSearch()"
				class="search" />
			<el-button icon="el-icon-search" size="mini" class="btnInsert" @click="brandSearch()" type="primary">搜索</el-button> -->
			<el-select v-model="select" slot="prepend" :placeholder="this.$t('carsmanage.carbrand.hint1')" style="width: 135px">
				<el-option :label="this.$t('carsmanage.carbrand.select.brandcn')" value="1"></el-option>
				<el-option :label="this.$t('carsmanage.carbrand.select.branden')" value="2"></el-option>
			</el-select>
			<el-input :placeholder="this.$t('carsmanage.carbrand.hint2')" v-model="search" class="input-with-select" style="width: 40%;" @keyup.enter.native="brandSearch()">
				<el-button type="info" slot="append" @click="brandSearch()" icon="el-icon-search"></el-button>
			</el-input>
			<el-button icon="el-icon-plus" type="success" size="mini" @click="openInsertCar" class="btnInsert">{{$t('carsmanage.carbrand.insert.title')}}
			</el-button>
		</div>
		<el-table :data="brands" style="width: 100%">
			<el-table-column label="id"  prop="" width="80px" show-overflow-tooltip>
				<template slot-scope="scope">
					<el-span type='text'>{{scope.row.id}}</el-span>
				</template>
			</el-table-column>
			<el-table-column :label="this.$t('carsmanage.carbrand.insert.brandcn')" prop="brandC" width="200px"> </el-table-column>
			<el-table-column :label="this.$t('carsmanage.carbrand.insert.branden')" prop="brandE" width="200px"> </el-table-column>
			<el-table-column :label="this.$t('carsmanage.carbrand.operate')" prop="">
				<template slot-scope="scope">
					<el-tag type="warning" class="btn" @click="openUpdateCar(scope.row)">{{$t('carsmanage.carbrand.modify.btn')}}</el-tag>
					<el-tag type="danger" class="btn" @click="deleteOneCar(scope.row.id)">{{$t('carsmanage.carbrand.delete')}}</el-tag>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
			:page-sizes="[5, 10, 15, 20]" :page-size="length" layout="total, sizes, prev, pager, next, jumper"
			:total="total" class="pagination">
		</el-pagination>
		<!-- 新增、修改品牌框 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false">
			<el-form :model="brandForm">
				<el-form-item :label="this.$t('carsmanage.carbrand.insert.brandid')" :label-width="formLabelWidth" v-if="dialogTitle == this.$t('carsmanage.carbrand.modify.title')">
					<el-input v-model="brandForm.id" autocomplete="off" @input="change($event)" :disabled="true">
					</el-input>
				</el-form-item>
				<el-form-item :label="this.$t('carsmanage.carbrand.insert.brandcn')" :label-width="formLabelWidth">
					<el-input v-model="brandForm.brandC" autocomplete="off" @input="change($event)"></el-input>
				</el-form-item>
				<el-form-item :label="this.$t('carsmanage.carbrand.insert.branden')" :label-width="formLabelWidth">
					<el-input v-model="brandForm.brandE" autocomplete="off" @input="change($event)"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancle()">{{$t('carsmanage.carbrand.cancel')}}</el-button>
				<el-button type="primary" @click="toBrand()">{{btnName}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				brands: [{
						id: 0,
						brandC: '',
						brandE: ''
					}],
				brandForm: {
					id: 0,
					brandC: '',
					brandE: ''
				},
				search: "",
				select: '',
				length: 5,
				page: 1,
				total: 0,
				dialogWidth: "30%",
				dialogTitle: '新增品牌',
				dialogFormVisible: false,
				btnName: '新增',
				formLabelWidth: '120px'
			};
		},
		created() {
			this.reload();
		},
		methods: {
			change(e) {
				this.$forceUpdate();
			},
			reload() {
				let that = this;
				let length = that.length;
				let page = that.page;
				let search = that.search;
				let select = that.select;
				if(search != '' && select == 1){
					that.getRequest('/tpa-api/manageCar/getCarBrand?length=' + length + '&page=' + page + '&keyword=' + search + '&option=1',
						null).then(
						resp => {
							if (resp.code == 200) {
								that.brands = resp.result;
								that.total = resp.total;
							}
						});
				} else if(search != '' && select == 2){
					that.getRequest('/tpa-api/manageCar/getCarBrand?length=' + length + '&page=' + page + '&keyword=' + search + '&option=2',
						null).then(
						resp => {
							if (resp.code == 200) {
								that.brands = resp.result;
								that.total = resp.total;
							}
						});
				} else {
					that.getRequest('/tpa-api/manageCar/getCarBrand?length=' + length + '&page=' + page + '&option=0', null).then(
						resp => {
							if (resp) {
								that.brands = resp.result;
								that.total = resp.total;
							}
						});
				}
				
			},
			// 分页功能
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.length = val;
				this.reload();
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.page = val;
				this.reload();
			},
			cancle() {
				this.dialogFormVisible = false;
			},
			brandSearch() {
				let that = this;
				let length = that.length;
				let page = that.page = 1;
				let search = that.search;
				let select = that.select;
				if(select == ''){
					this.$message('请选择要查询的类型');
					return;
				}
				
				
				if(select == 1){
					that.getRequest('/tpa-api/manageCar/getCarBrand?length=' + length + '&page=' + page + '&keyword=' + search + '&option=1',
						null).then(
						resp => {
							if (resp.code == 200) {
								that.brands = resp.result;
								that.total = resp.total;
							}
						});
				} else {
					that.getRequest('/tpa-api/manageCar/getCarBrand?length=' + length + '&page=' + page + '&keyword=' + search + '&option=2',
						null).then(
						resp => {
							if (resp.code == 200) {
								that.brands = resp.result;
								that.total = resp.total;
							}
						});
				}
				
			},
			openInsertCar() {
				this.brandForm = {};
				this.dialogTitle = this.$t('carsmanage.carbrand.insert.title');
				this.btnName = this.$t('carsmanage.carbrand.insert.btn');
				this.dialogFormVisible = true;
			},
			openUpdateCar(row) {
				this.brandForm.id = row.id;
				this.brandForm.brandC = row.brandC;
				this.brandForm.brandE = row.brandE;
				this.dialogFormVisible = true;
				this.dialogTitle = this.$t('carsmanage.carbrand.modify.title');
				this.btnName = this.$t('carsmanage.carbrand.modify.btn');
			},
			deleteOneCar(id) {
				// 跳出确认框
				let that = this;
				that.$confirm(this.$t('notification.carbrandmessage'), this.$t('notification.title'), {
					confirmButtonText: this.$t('notification.confirm'),
					cancelButtonText: this.$t('notification.cancel'),
					type: 'warning'
				}).then(() => {
					// 发送ajax请求删除数据
					that.deleteRequest('/tpa-api/manageCar/deleteCarBrand/' + id, null).then(resp => {
						if (resp.code == 200) {
							// let index = that.cars.findIndex(one => {
							// 	if (one.id == id) {
							// 		return true;
							// 	}
							// });
							// // 删除carInfo中被删除的内容
							// that.cars.splice(index, 1)
							// 重新加载
							that.page=1;
							that.length = 5;
							that.reload();
						}
					});
				}).catch(() => {
					that.$message({
						type: 'info',
						message: this.$t('notification.cancelinfo')
					});
				});
			},
			toBrand() {
				let that = this;
				let btnName = that.btnName;
				let insertData = {
					brandC: that.brandForm.brandC,
					brandE: that.brandForm.brandE
					
				};
				if (btnName == '新增') {
					that.postRequest('/tpa-api/manageCar/insertCarBrand', insertData).then(
						resp => {
							if (resp.code == 200) {
								// 关闭对话框，刷新页面
								that.dialogFormVisible = false;
								that.reload();
							}
						});
				} else if (btnName == '修改') {
					let updateData = {
						brandId: that.brandForm.id,
						brandC: that.brandForm.brandC,
						brandE: that.brandForm.brandE
					};
					that.postRequest('/tpa-api/manageCar/updateCarBrand', updateData).then(
						resp => {
							if (resp.code == 200) {
								// 关闭对话框，刷新页面
								that.dialogFormVisible = false;
								that.reload();
							}
						});
				}
			}

		}
	};
</script>
<style scoped>
	.avatar {
		height: 50px;
	}

	.pagination {
		display: flex;
		float: left;
		margin-left: 10px;
		margin-top: 40px;
	}

	.btnInsert {
		margin-left: 50px;
		height: 36px;
		font-size: 10px;
		line-height: 10px;
		float: right;
	}

	.search {
		width: 30%;
		height: 50px;

	}

	.header {
		display: flex;
		flex-direction: row;
	}

	.btn {
		cursor: pointer;
	}
</style>
